// extracted by mini-css-extract-plugin
export var button = "_4w-0";
export var icon = "_4w-1";